import "./splitButton.scss";

import { List } from "immutable";
import PropTypes from "prop-types";
import React, { createRef, Fragment, PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import keyConstants from "../../constants/keyConstants";
import { getLabelWithUntitled } from "../../utils/labelUtils";
import ColorDot from "../interface/ColorDot";
import Icon from "../interface/Icon";
import ListItemView from "../listView/ListItemView";
import ListView from "../listView/ListView";
import FormSearchField from "./FormSearchField";

class SplitButtonOptionGroup extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      searchText: "",
      highlightOptionIndex: -1
    };
    this.selectOption = this.selectOption.bind(this);
    this.searchChanged = this.searchChanged.bind(this);
    this.renderList = this.renderList.bind(this);
    this.optionRenderer = this.optionRenderer.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onDownArrow = this.onDownArrow.bind(this);

    this._listViewDom = null;
    this._searchRef = createRef();
  }

  selectOption(option) {
    this.setState(
      {
        searchText: ""
      },
      () => {
        this.props.togglePopover();
        this.props.onSelectOption(option);
      }
    );
  }

  searchChanged(searchText) {
    this.setState({ searchText, highlightOptionIndex: -1 });
  }

  renderMenuSearch() {
    let autoFocusProp = {};
    if (this.props.autoFocus) {
      autoFocusProp.autoFocus = true;
    }

    return (
      <FormSearchField
        //#!if iOS !== true
        autoFocus={true}
        //#!endif
        ref={this._searchRef}
        placeholder="Filter"
        value={this.state.searchText}
        onChange={this.searchChanged}
        onDownArrow={this.onDownArrow}
        continuouslyUpdates={true}
        showSearchIcon={true}
        showClearIcon={true}
      />
    );
  }

  onDownArrow() {
    this._listViewDom ? this._listViewDom.focus() : null;
    this.setState({ highlightOptionIndex: 0 });
  }

  onKeyDown(e) {
    if (e.key === keyConstants.Down) {
      this._listViewDom ? this._listViewDom.focus() : null;
      this.setState({ highlightOptionIndex: 0 });
    } else {
      this._searchRef && this._searchRef.current ? this._searchRef.current.focus() : null;
    }
  }

  getOptions() {
    const lowerSearch = this.state.searchText.toLowerCase();
    let filteredOptions = lowerSearch
      ? this.props.options.filter(opt => getLabelWithUntitled(opt.label).toLowerCase().indexOf(lowerSearch) >= 0)
      : this.props.options;

    if (!filteredOptions) {
      filteredOptions = new List();
    }
    return filteredOptions;
  }

  getOnDeleteOptionFunc(optId, optLabel) {
    return e => {
      e.stopPropagation();
      this.props.onDeleteOption(optId, optLabel);
    };
  }

  optionRenderer(option, isSelected, ref) {
    const leftElements = option.icon ? (
      <Icon icon={option.icon} color={option.color ? option.color : "mono"} />
    ) : option.color ? (
      <div className="colorDotWrapper">
        <ColorDot color={option.color} />
      </div>
    ) : null;
    const middleElements = <span className="splitButtonOptionLabel">{getLabelWithUntitled(option.label)}</span>;
    const rightElements =
      option.canDelete && this.props.onDeleteOption ? (
        <Icon
          tooltip="Delete"
          className="splitButtonDeleteIcon"
          icon="listDelete"
          color="mono"
          onClick={this.getOnDeleteOptionFunc(option.id, option.label)}
        />
      ) : null;
    return (
      <ListItemView
        key={option.id}
        ref={ref}
        onClick={this.selectOption.bind(this, option.id)}
        leftElements={leftElements}
        middleElements={middleElements}
        rightElements={rightElements}
        isSelected={isSelected}
      />
    );
  }

  getListView() {
    const options = this.getOptions();
    const onItemClick = newIndex => this.selectOption(options.find((opt, index) => index === newIndex).id);

    return (
      <ListView
        className="relationshipPopoverList"
        selectedItemIndex={this.state.highlightOptionIndex}
        items={options}
        onItemSelect={onItemClick}
        itemRenderer={this.optionRenderer}
        getDom={listViewDom => (this._listViewDom = listViewDom)}
        autoFocus={this.props.showSearch ? false : this.props.autoFocus}
      />
    );
  }

  renderList() {
    return (
      <Fragment>
        {this.props.showTitle ? <div className="title">{this.props.title}</div> : null}
        {this.props.options.size ? (
          <Fragment>
            {this.props.showSearch ? this.renderMenuSearch() : null}
            {this.getListView()}
          </Fragment>
        ) : null}
      </Fragment>
    );
  }

  render() {
    return this.props.options.size ? (
      <div className="splitButtonOptionGroup" onKeyDown={this.onKeyDown}>
        {this.renderList()}
      </div>
    ) : null;
  }
}

SplitButtonOptionGroup.propTypes = {
  title: PropTypes.string,
  id: PropTypes.string.isRequired,
  options: ImmutablePropTypes.list,
  showTitle: PropTypes.bool,
  showSearch: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onSelectOption: PropTypes.func.isRequired,
  onDeleteOption: PropTypes.func,
  togglePopover: PropTypes.func.isRequired
};

SplitButtonOptionGroup.defaultProps = {
  options: List()
};

export default SplitButtonOptionGroup;
